module.exports = __webpack_public_path__ + "img/credenciales-google.db335564.svg";